<form-control-container
  #container
  [control]="controlInstance"
  [class.readonly]="isReadonlyValue"
>
  <div label-extension>
    <ng-content select="[label-extension]"></ng-content>
  </div>
  <ng-container *ngIf="!isReadonlyValue">
    <input
      [(ngModel)]="value"
      type="password"
      class="form-control"
      [ngClass]="{ invalid: invalid }"
      [id]="controlId"
      [attr.name]="inputName"
      (focusout)="touch()"
      [autocomplete]="autocomplete ? 'current-password' : 'new-password'"
      [attr.maxlength]="maxLength"
      [attr.tabindex]="tabindex"
      [attr.placeholder]="placeholder"
    />
  </ng-container>
  <ng-container *ngIf="isReadonlyValue">
    <span class="readonly-value">{{ value ? "******" : "" }}</span>
  </ng-container>
</form-control-container>
